import { gql } from '@apollo/client/core';
import ConfigurationFragment from '@/apollo/fragments/Portfolio/PortfolioConfiguration.fragment';
import EducationHistoryFragment from '@/apollo/fragments/Portfolio/PortfolioEducationHistory.fragment';

const PublicPortfolioUserQuery = gql`
  ${ConfigurationFragment}
  ${EducationHistoryFragment}

  query PublicPortfolioUser($slug: String!) {
    publicPortfolioUser(slug: $slug) {
      departments {
        id
        name
      }
      companyStages {
        id
        name
      }
      warRoomSalesRoles {
        id
        name
      }
      industries {
        id
        name
      }
      productTypes {
        id
        name
      }
      companySeriesStages {
        id
        name
        slug
      }
      testimonials {
        id
        sign
        skills
        author {
          avatarUrl
          firstname
          jobTitle
          lastname
        }
        requestor {
          firstname
          lastname
          slug
        }
        position
        description
        state
      }
      configuration {
        ...ConfigurationFragment
      }
      educationHistories {
        ...EducationHistoryFragment
      }
    }
  }
`;

export default PublicPortfolioUserQuery;
